import {
    measureAttributeDefinitions,
    typeAttributeKeys,
} from "@treegram/viewer-core";

import Select from "@/components/select";

const symbolOptions = [
    { value: "circle", label: "Cercle" },
    { value: "square", label: "Carré" },
    { value: "diamond", label: "Losange" },
];

interface Props {
    role: "representation" | "business";
    disabled?: boolean;
    representationId: string;
    values?: Record<string, unknown>;
}

export default function MeasureTypeFields({
    representationId,
    values = {},
    role,
    disabled = false,
}: Props) {
    const keys = typeAttributeKeys(representationId, values).filter(
        (key) => key !== "color" && key !== "alpha",
    );
    const fields = keys.filter(
        (key) => measureAttributeDefinitions[key]?.role === role,
    );
    if (!fields.length) return null;

    return (
        <div className="grid grid-cols-[auto_1fr] gap-3 items-center">
            {fields.map((key) => {
                const definition = measureAttributeDefinitions[key];
                const value =
                    values[key] ??
                    (
                        {
                            graphic_thickness: 0.005,
                            diameter: 0.1,
                            symbol: "circle",
                        } as Record<string, unknown>
                    )[key];
                let displayValue = value == null ? "" : String(value);
                if (typeof value === "number" && definition.unit === "m") {
                    displayValue = String(Number((value * 100).toFixed(6)));
                }

                return (
                    <label key={key} className="contents">
                        <span>
                            {definition.label}
                            {definition.unit &&
                                ` (${definition.unit === "m" ? "cm" : definition.unit})`}
                        </span>
                        {key === "symbol" ? (
                            <Select
                                name="dataFormatType_symbol"
                                isDisabled={disabled}
                                aria-label={definition.label}
                                options={symbolOptions}
                                defaultValue={symbolOptions.find(
                                    (option) => option.value === value,
                                )}
                            />
                        ) : (
                            <input
                                name={`dataFormatType_${key}`}
                                type="number"
                                required
                                aria-label={definition.label}
                                step="any"
                                min={key === "offset" ? 0 : 0.001}
                                defaultValue={displayValue}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6"
                            />
                        )}
                    </label>
                );
            })}
        </div>
    );
}
